import React, { useContext, useEffect, useRef, useState } from 'react';
import { GlobalBannerContext } from './GlobalBannerContext';

interface IScrollContext {
  headerRef: React.MutableRefObject<HTMLDivElement>;
  headerPadding: number;
}

export const ScrollContext = React.createContext<Partial<IScrollContext>>({});
export const ScrollContextProvider = ({ children }) => {
  const headerRef = useRef<HTMLDivElement>();
  const [headerPadding, setHeaderPadding] = useState(0);
  const {banners} = useContext(GlobalBannerContext);
  useEffect(() => {
    const recalcPadding = () => {
      const padding = headerRef.current?.getBoundingClientRect().height + 2;
      if(headerPadding !== padding) setHeaderPadding(padding);
    }
    recalcPadding();
    window.addEventListener('resize', recalcPadding);
    return () => window.removeEventListener('resize', recalcPadding);
  }, [headerPadding, headerRef.current, banners]);
  return (
    <ScrollContext.Provider value={{
      headerRef,
      headerPadding,
    }}>
      {children}
    </ScrollContext.Provider>
  );
};
